import { inject, Injectable } from '@angular/core'
import {
  ActivatedRouteSnapshot,
  createUrlTreeFromSnapshot,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router'
import { ElderToastService } from '@elderbyte/ngx-starter'
import { EMPTY, Observable } from 'rxjs'
import { catchError, map } from 'rxjs/operators'
import { ControlTerminalService } from '../control-terminal.service'

type CanActivateResponse =
  Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree

/**
 * Populates the workCenterId param and redirects to real route
 */
@Injectable({
  providedIn: 'root',
})
export class TerminalGotoFirstActivator {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  private controlTerminalService = inject(ControlTerminalService)
  private toastService = inject(ElderToastService)

  /***************************************************************************
   *                                                                         *
   * Public API                                                              *
   *                                                                         *
   **************************************************************************/

  canActivate(route: ActivatedRouteSnapshot, _: RouterStateSnapshot): CanActivateResponse {
    const terminalId: string | undefined = route.parent?.params['terminalId']
    if (!terminalId) {
      return EMPTY
    }
    return this.controlTerminalService
      .findById(terminalId) // todo: eliminate duplicate fetch
      .pipe(
        catchError((err) => {
          this.toastService.error('messages.loading_failed', err)
          return EMPTY
        })
      )
      .pipe(
        map((terminal) => {
          const terminalWorkCenters = terminal.workCenters
          if (terminalWorkCenters.length === 0) {
            this.toastService.error('messages.loading_failed', {})
            return false
          } else {
            const workCenterId = terminalWorkCenters[0].id // just take the first one
            const { queryParams } = route // move to the end
            const urlTree = createUrlTreeFromSnapshot(route, [workCenterId, 'orders'], {
              queryParams,
            })
            console.debug(`built url tree for redirect: ${urlTree}`)
            return urlTree
          }
        })
      )
  }
}
